<template>
  <div style="padding: 15px;">
    <header-back :title="getTitle" :canBack="true" :onBack="goBack" :isCross="isCross">
    </header-back>
    <hr>
  <div>
    <div class="w-100 style25Exist" v-if="actualPage === pageList.existUBO">
      {{ $t('iframe_page.does_pp_25_exist') }}
      <div class="row no-gutter my-4">
        <div class="text-center m-0 selectionBloc"
          :class="{selectionBlocActive : moreThan25percentEmployee === 'yes'}"
          @click="moreThan25percentEmployee = 'yes'">
          <label class="m-0">
            {{ $t('iframe_page.yes') }}
          </label>
        </div>
        <div class="text-center m-0 selectionBloc"
          :class="{selectionBlocActive : moreThan25percentEmployee === 'no'}"
          @click="moreThan25percentEmployee = 'no'">
          <label class="m-0">
            {{ $t('iframe_page.no') }}
          </label>
        </div>
      </div>
      <div v-if="moreThan25percentEmployee === 'yes'">
        <button
          @click="actualPage = pageList.nbrUBO"
          type="button"
          class="validation-btn btn-next">
          {{ $t('common.next') }}
        </button>
      </div>
      <div v-if="moreThan25percentEmployee === 'no'">
        <label class="information_check_no">
          {{ $t('iframe_page.check_informations_2')}}
        </label>
        <!-- Si finalement il a des actionnaires à déclarer -->
        <div class="row">
          <div class="col-md-12 no-gutter">
            <button @click="actualPage = pageList.warningUBO" type="button" class="validation-btn btn-next">
              {{ $t('common.transmit_declaration') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <br> -->

    <div class="row no-gutter" v-if="actualPage === pageList.nbrUBO">
      <div class="w-100">
        {{ $t('common.number_shareholder') }}
      </div>
      <div class="col-2 p-0" v-for="availableNumber in availableMoreThan25PersonNumber">

        <div class="selectionBloc w-100"  @click="numberOfMoreThan25 = availableNumber"
          :class="{selectionBlocActive : numberOfMoreThan25 === availableNumber}" v-if="!hiddenNbrUBO_2">
          {{ availableNumber }}
        </div>
      </div>
      <button :disabled="!numberOfMoreThan25" @click="btnValidateUboNbr" type="button" class="validation-btn btn-next mt-4">
        {{ $t('common.next') }}
      </button>
    </div>
    <div v-if="actualPage === pageList.UBODetails">
      <shareholder
        :key="actualShareholder"
        :shareholderNumber="actualShareholder"
        :shareholderMaxNumber="numberOfMoreThan25"
        v-model="shareholderList[actualShareholder - 1]"
        @input="refreshShareholderList">
      </shareholder>
      <small v-if="showWarning">{{ $t('iframe_page.mandatory_field')}}</small>
      <button v-if="!isLastShareholder"
        type="button"
        class="validation-btn btn-next"
        style="margin-top: 10%;"
        @click="nextShareHolder()">
         {{ $t('common.next') }}
      </button>
      <button v-if="isLastShareholder"
        type="button"
        class="validation-btn btn-next"
        style="margin-top: 6%;"
        :disabled="!isActiveBtnTransmited" @click="saveShareHolder">
         {{ $t('common.transmit_declaration') }}
      </button>
      <button v-if="isLastShareholder"
        class="styleSaveDeclaration"
        @click="saveDraftShareholder()">
        {{ $t('iframe_page.save_declaration') }}
      </button>
    </div>

    <div v-if="actualPage === pageList.warningUBO">
      <!-- exclamation triangle svp -->
      <svg class="pos-svg" width="95" height="94" viewBox="0 0 95 94" fill="none">
        <path d="M92.6651 76.5066L56.7628 6.14165C55.8123 4.28334 54.4085 2.73211 52.6992 1.65128C50.9899 0.570444 49.0383 0 47.05 0C45.0617 0 43.1101 0.570444 41.4008 1.65128C39.6915 2.73211 38.2877 4.28334 37.3372 6.14165L1.39802 76.5066C0.457353 78.3032 -0.0243427 80.3308 0.00094687 82.3873C0.0262364 84.4437 0.557628 86.4572 1.54215 88.227C2.52668 89.9968 3.92995 91.4612 5.61209 92.474C7.29423 93.4869 9.19649 94.013 11.1292 93.9998H82.9339C84.8508 94.0016 86.7352 93.4732 88.4023 92.4664C90.0695 91.4596 91.462 90.0089 92.4433 88.2568C93.4246 86.5046 93.961 84.511 93.9999 82.4717C94.0388 80.4324 93.5788 78.4174 92.6651 76.6243V76.5066ZM41.5393 29.3019C41.5393 27.7416 42.1218 26.2451 43.1587 25.1418C44.1957 24.0384 45.602 23.4186 47.0684 23.4186C48.5348 23.4186 49.9412 24.0384 50.9781 25.1418C52.015 26.2451 52.5975 27.7416 52.5975 29.3019V42.8141V56.3262C52.5975 57.8865 52.015 59.383 50.9781 60.4863C49.9412 61.5897 48.5348 62.2095 47.0684 62.2095C45.602 62.2095 44.1957 61.5897 43.1587 60.4863C42.1218 59.383 41.5393 57.8865 41.5393 56.3262V42.8141V29.3019ZM47.2159 82.2914C45.9619 82.2914 44.7361 81.8957 43.6935 81.1544C42.6509 80.4131 41.8383 79.3595 41.3584 78.1268C40.8786 76.8941 40.753 75.5376 40.9976 74.229C41.2423 72.9203 41.8461 71.7183 42.7328 70.7748C43.6194 69.8313 44.7491 69.1888 45.979 68.9285C47.2088 68.6682 48.4836 68.8018 49.6421 69.3124C50.8006 69.823 51.7908 70.6877 52.4874 71.7971C53.1841 72.9065 53.5559 74.2108 53.5559 75.5451C53.5559 77.3343 52.8879 79.0503 51.6989 80.3154C50.5099 81.5806 48.8973 82.2914 47.2159 82.2914Z" fill="#49A0A2"/>
      </svg>
      <p class="styleSpan">
        {{ $t('iframe_page.shareholder_error') }}<br><br>
        {{ $t('iframe_page.need_help') }}<br>
        {{ $t('iframe_page.contact_service') }}<br>
        {{ $t('iframe_page.service_client') }}
      </p>
      <button
        class="btn-next mt-5"
        type="button"
        @click="actualPage = pageList.nbrUBO">
        {{ $t('iframe_page.declare_shareholder') }}
      </button>
      <div class="w-100 text-center mt-4">
        <label class="styleSaveDeclaration"> {{ $t('iframe_page.plus_shareholder') }} </label>
      </div>
    </div>
    <div v-if="actualPage === pageList.UBOSaved">
      <svg class="pos-svg-2" width="102" height="102" viewBox="0 0 102 102" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 51C0 22.8329 22.8341 0 51 0C79.1659 0 102 22.8329 102 51C102 79.1671 79.1659 102 51 102C22.8341 102 0 79.1671 0 51ZM63.3177 38.447C65.1282 36.6377 68.0641 36.6377 69.8746 38.447C71.6875 40.2587 71.6851 43.1935 69.8735 45.004L50.2037 64.6738C48.3932 66.4843 45.4561 66.4843 43.6456 64.6738L33.8118 54.8412C32.0013 53.0295 32.0013 50.0936 33.8118 48.2831C35.6235 46.4726 38.5583 46.4726 40.3688 48.2831L46.9258 54.84L63.3177 38.447Z" fill="#49A0A2"/>
      </svg>
      <p class="styleSpan" style="margin-top: -5%"> {{ $t('iframe_page.thanks') }}</p>
      <p class="styleSpan"> {{ $t('iframe_page.declaration_transmited') }}</p>
      <p class="styleSpan"> {{ $t('iframe_page.declaration_transmited_2') }}</p>
      <button
        class="validation-btn style-btn-document"
        style="margin-bottom: 10%">
        {{ $t('iframe_page.handler_document') }}
      </button>
      <button class="validation-btn style-btn-chantier">
        {{ $t('iframe_page.find_chantier') }}
      </button>
    </div>
    <div v-if="actualPage === pageList.UBODraftSaved">
      <svg class="pos-svg" width="102" height="102" viewBox="0 0 102 102" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 51C0 22.8329 22.8341 0 51 0C79.1659 0 102 22.8329 102 51C102 79.1671 79.1659 102 51 102C22.8341 102 0 79.1671 0 51ZM63.3177 38.447C65.1282 36.6377 68.0641 36.6377 69.8746 38.447C71.6875 40.2587 71.6851 43.1935 69.8735 45.004L50.2037 64.6738C48.3932 66.4843 45.4561 66.4843 43.6456 64.6738L33.8118 54.8412C32.0013 53.0295 32.0013 50.0936 33.8118 48.2831C35.6235 46.4726 38.5583 46.4726 40.3688 48.2831L46.9258 54.84L63.3177 38.447Z" fill="#49A0A2"/>
      </svg>
      <p class="styleSpan"> {{ $t('iframe_page.declaration_saved') }}</p>
      <p class="styleSpan"> {{ $t('iframe_page.declaration_saved_2') }}</p>
      <button
        @click="goBack"
        class="validation-btn style-btn-document"
        style="margin-bottom: 10%">
        {{ $t('iframe_page.handler_document') }}
      </button>
      <button class="validation-btn style-btn-chantier">
        {{ $t('iframe_page.find_chantier') }}
      </button>
    </div>
  </div>
</div>
</template>
<script>

import HeaderBack from './HeaderBack.vue'
import Shareholder from './Shareholder.vue'

/** @author TLV 08/02/2021
* @brief Formulaire intégré en iframe sur une autre application pour envoyer des
*       documents de paiement
*/
export default {
  name: 'DocumentUboView',
  props: {
    doctype: {
      type: String
    },
    docstatus: {
      type: String
    },
    filename: {
      type: String
    },
    ubos: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    'header-back': HeaderBack,
    'shareholder': Shareholder
  },
  computed: {
    test: {
      get () {
        return this.shareholderList[this.actualShareholder - 1]
      },
      set (val) {
        this.shareholderList[this.actualShareholder - 1] = val
        this.shareholderList = this.shareholderList
      }
    },
    isActiveBtnTransmited () {
      return this.shareholderList.map(elem => elem.documents &&
                                            elem.documents.length &&
                                            elem.gender &&
                                            elem.firstname &&
                                            elem.lastname &&
                                            elem.birthdate &&
                                            elem.birthtown &&
                                            elem.birthcountry &&
                                            elem.nationality &&
                                            elem.id_card_number &&
                                            elem.percentage &&
                                            elem.proofOfAdress &&
                                            this.hasProofOfAdressDocs(elem.proofOfAdress)).filter(elem => elem).length === this.numberOfMoreThan25
    },
    getTitle () {
      switch (this.actualPage) {
        case this.pageList.UBOSaved:
          return this.$t('iframe_page.declare_shareholder_transmited')
        case this.pageList.UBODraftSaved:
          return this.$t('iframe_page.info_saved')
        default:
          return this.$t('iframe_page.shareholder_declaration')
      }
    },
    isCross () {
      return this.actualPage === this.pageList.UBOSaved ||
             this.actualPage === this.pageList.warningUBO ||
             this.actualPage === this.pageList.UBODraftSaved
    },
    isLastShareholder () {
      return this.actualShareholder === this.numberOfMoreThan25
    },
    isTransmited () {
      return this.actualPage === this.pageList.UBOSaved
    },
    isSaved () {
      return this.actualPage === this.pageList.UBODraftSaved
    }
  },
  data () {
    return {
      moreThan25percentEmployee: '',
      numberOfMoreThan25: 0,
      availableMoreThan25PersonNumber: [1, 2, 3, 4],
      hiddenNbrUBO_2: false,
      showWarning: false,
      actualShareholder: 1,
      shareholderList: [],
      docListToSend: [],
      actualPage: 0,
      isDraft: true,
      finalDocData: '',
      pageList: {
        existUBO: 0,
        warningUBO: 1,
        nbrUBO: 2,
        UBODetails: 3,
        UBODraftSaved: 4,
        UBOSaved: 5
      }
    }
  },
  created () {
    this.fillDocs(this.ubos)
  },
  mounted () {
  },
  watch: {
    ubos: function (newUbos, oldUbos) {
      this.fillDocs(newUbos)
    }
  },
  methods: {
    addUBO (indexShareholder) {
      let that = this
      if (indexShareholder >= this.numberOfMoreThan25) {
        if (!this.isDraft) {
          this.$engine.services.suppliers.uploadDocument({
            DocumentType: 'UBO_DECLARATION',
            DocumentName: 'declaration_actionnaires.pdf',
            ocr: '0',
            DocumentData: this.finalDocData,
            Serialize: {}
          })
          .then(response => {
            this.actualPage = this.pageList.UBOSaved
          })
          .catch(err => {
            console.log(err)
          })
        } else {
          this.actualPage = this.pageList.UBODraftSaved
        }
      } else {
        if (that.shareholderList[indexShareholder].IdUBO !== undefined) {
          that.docListToSend = that.reduceDocsList(that.shareholderList[indexShareholder].documents)
          Object.keys(that.shareholderList[indexShareholder].proofOfAdress).forEach(key => {
            let docs = that.reduceDocsList(that.shareholderList[indexShareholder].proofOfAdress[key])
            if (docs.length) {
              that.docListToSend = that.docListToSend.concat(docs)
            }
          })
          this.uploadDocument(indexShareholder, 0)
        } else {
          this.$engine.services.suppliers.addUBO({
            Siren: that.$engine.services.suppliers.selectedSupplier.Siren,
            IdExchangeGroup: that.$engine.services.suppliers.selectedSupplier.IdGroupDocument,
            UBO: {
              LastName: this.shareholderList[indexShareholder].lastname,
              FirstName: this.shareholderList[indexShareholder].firstname,
              PercentageDetention: this.shareholderList[indexShareholder].percentage.replace('%', ''),
              IsLegalRepresentative: '0'
            }
          })
          .then(response => {
            that.shareholderList[indexShareholder].IdUBO = response.data.IdUBO
            that.docListToSend = that.reduceDocsList(that.shareholderList[indexShareholder].documents)
            that.docListToSend[0].IdDocument = response.data.IdDocumentBeneficialCNI
            Object.keys(that.shareholderList[indexShareholder].proofOfAdress).forEach(key => {
              let docs = that.reduceDocsList(that.shareholderList[indexShareholder].proofOfAdress[key])
              if (docs.length) {
                if (key === 'proofHostDocs' || key === 'billDocs' || key === 'receipeDocs') {
                  docs[0].IdDocument = response.data.IdDocumentBeneficialProofOfAddress
                }
                that.docListToSend = that.docListToSend.concat(docs)
              }
            })
            that.uploadDocument(indexShareholder, 0)
          })
        }
      }
    },
    btnValidateUboNbr () {
      this.actualPage = this.pageList.UBODetails

      this.shareholderList = []
      for (let i = 0; this.numberOfMoreThan25 > i; i++) {
        this.shareholderList.push({})
      }
    },
    fillDocs (ubos) {
      let that = this
      if (ubos.length) {
        this.numberOfMoreThan25 = ubos.length
        for (let i = 0; i < this.numberOfMoreThan25; i++) {
          this.shareholderList.push({})
        }
        ubos.forEach((ubo, uboIndex) => {
          that.shareholderList[uboIndex].documents = ubo.Documents.filter(elem => elem.Type === 'IDCARD' && !elem.Serialize.realDocType)
          that.shareholderList[uboIndex].percentage = ubo.PercentageDetention.toString()
          that.shareholderList[uboIndex].firstname = ubo.FirstName
          that.shareholderList[uboIndex].lastname = ubo.LastName
          that.shareholderList[uboIndex].IdUBO = ubo.IdUBO
          let parsedInfos = {}
          that.shareholderList[uboIndex].documents.forEach(document => {
            if (document.Serialize) {
              parsedInfos = Object.assign(parsedInfos, document.Serialize)
            }
          })
          that.shareholderList[uboIndex].gender = parsedInfos.gender
          that.shareholderList[uboIndex].birthdate = parsedInfos.birthdate
          that.shareholderList[uboIndex].birthtown = parsedInfos.birthtown
          that.shareholderList[uboIndex].birthcountry = parsedInfos.birthcountry
          that.shareholderList[uboIndex].nationality = parsedInfos.nationality
          that.shareholderList[uboIndex].id_card_number = parsedInfos.id_card_number
          that.shareholderList[uboIndex].proofOfAdress = {}
          that.shareholderList[uboIndex].proofOfAdress.billDocs = ubo.Documents.filter(elem => elem.Type === 'PROOF_OF_ADDRESS' && elem.Serialize.realDocType === 'BILL')
          that.shareholderList[uboIndex].proofOfAdress.receipeDocs = ubo.Documents.filter(elem => elem.Type === 'PROOF_OF_ADDRESS' && elem.Serialize.realDocType === 'RECEIPE')
          that.shareholderList[uboIndex].proofOfAdress.proofHostDocs = ubo.Documents.filter(elem => elem.Type === 'PROOF_OF_ADDRESS' && elem.Serialize.realDocType === 'PROOFADDRESSHOST')
          that.shareholderList[uboIndex].proofOfAdress.idHostDocs = ubo.Documents.filter(elem => elem.Type === 'IDCARD' && elem.Serialize.realDocType === 'IDHOST')
          that.shareholderList[uboIndex].proofOfAdress.declareDocs = ubo.Documents.filter(elem => elem.Type === 'PROOF_OF_ADDRESS' && elem.Serialize.realDocType === 'DECLARE')
          if (ubos.length > 0) {
            this.actualPage = this.pageList.UBODetails
          }
        })
      }
    },
    getUBODocSerialize (doc, indexUbo) {
      let tmp = {}
      if (doc.Type === 'IDCARD') {
        tmp.birthcountry = this.shareholderList[indexUbo].birthcountry
        tmp.birthdate = this.shareholderList[indexUbo].birthdate
        tmp.birthtown = this.shareholderList[indexUbo].birthtown
        tmp.firstname = this.shareholderList[indexUbo].firstname
        tmp.gender = this.shareholderList[indexUbo].gender
        tmp.id_card_number = this.shareholderList[indexUbo].id_card_number
        tmp.lastname = this.shareholderList[indexUbo].lastname
        tmp.nationality = this.shareholderList[indexUbo].nationality
        tmp.percentage = this.shareholderList[indexUbo].percentage
      } else {
        tmp.realDocType = doc.Type
      }
      return tmp
    },
    getUBODocType (doc) {
      return doc.Type === 'IDCARD' || doc.Type === 'IDHOST' ? 'IDCARD' : 'PROOF_OF_ADDRESS'
    },
    goBack () {
      switch (this.actualPage) {
        case this.pageList.existUBO:
          this.$emit('update:parent')
          break
        case this.pageList.warningUBO:
          this.actualPage = this.pageList.existUBO
          break
        case this.pageList.nbrUBO:
          this.actualPage = this.pageList.existUBO
          break
        case this.pageList.UBODetails:
          if (this.actualShareholder > 1) {
            this.actualShareholder--
          } else {
            this.actualPage = this.pageList.nbrUBO
          }
          break
        case this.pageList.UBODraftSaved:
          this.$emit('update:parent')
          break
        case this.pageList.UBOSaved:
          this.$emit('update:parent')
          break
      }
    },
    hasProofOfAdressDocs (proofOfAdress) {
      if (proofOfAdress.billDocs && proofOfAdress.billDocs.length) {
        return true
      }
      if (proofOfAdress.receipeDocs && proofOfAdress.receipeDocs.length) {
        return true
      }
      if (proofOfAdress.declareDocs && proofOfAdress.declareDocs.length &&
          proofOfAdress.idHostDocs && proofOfAdress.idHostDocs.length &&
          proofOfAdress.proofHostDocs && proofOfAdress.proofHostDocs.length) {
        return true
      }
      return false
    },
    nextShareHolder () {
      if (this.actualShareholder !== this.numberOfMoreThan25) {
        this.actualShareholder++
      }
    },
    reduceDocsList (docList) {
      let that = this
      if (!docList.length) {
        return []
      }
      let docsData = ''
      docList.forEach((item, i) => {
        if (!that.isDraft) {
          that.finalDocData += !that.finalDocData ? item.Data : ';' + item.Data.substring(item.Data.indexOf(',') + 1)
        }
        docsData += i === 0 ? item.Data : ';' + item.Data.substring(item.Data.indexOf(',') + 1)
      })
      docList[0].Data = docsData
      return [docList[0]]
    },
    refreshShareholderList (value) {
      this.shareholderList = this.shareholderList
    },
    saveDraftShareholder () {
      this.addUBO(0)
    },
    saveOrEditShareholder (shareholderData) {
      if (this.actualShareholder !== this.numberOfMoreThan25) {
        this.actualShareholder++
      }
    },
    saveShareHolder (isDraft = false) {
      this.isDraft = isDraft
      var totalPercentage = this.shareholderList.map(elem => parseFloat(elem.percentage)).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
      if (totalPercentage > 100) {
        this.$bus.$emit('mainNotif', { text: this.$t('errors.percentage_detention_between_total') })
        return
      }
      this.addUBO(0)
    },
    uploadDocument (indexUbo, indexDocument) {
      let that = this
      if (indexDocument >= this.docListToSend.length) {
        this.addUBO(indexUbo + 1)
      } else {
        this.$engine.services.suppliers.uploadDocument({
          IdDocument: this.docListToSend[indexDocument].IdDocument,
          IdUBO: that.shareholderList[indexUbo].IdUBO,
          DocumentType: this.getUBODocType(this.docListToSend[indexDocument]),
          DocumentName: this.docListToSend[indexDocument].Name,
          ocr: '0',
          DocumentData: this.docListToSend[indexDocument].Data,
          Serialize: this.getUBODocSerialize(this.docListToSend[indexDocument], indexUbo)
        })
        .then(response => {
          that.uploadDocument(indexUbo, indexDocument + 1)
        })
        .catch(err => {
          console.log(err)
        })
      }
    }
  }
}
//  if (this.actualShareholder > shareholderList.length) {

  // }
</script>
<style scoped>
.styleSpan {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #1B1918;
  text-align: center;
}
/* Ajouts sur selectionBloc utiles uniquement sur ce component (pas sur Shareholder) */
.selectionBloc {
  width: 43%;
}
.information_check {
  color: red;
}
.information_check_no {
  /* font-style: normal; */
  /* font-weight: normal; */
  text-align: justify;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #49A0A2;
}
.btn-next {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #FFFFFF;
  background-color: #49A0A2;
  height: 54px;
  width: 100%;
  border-radius: 2px;
  vertical-align: middle;
  border: 0px;
}
.style25Exist {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
  color: #1B1918;
}
.btnTransmit {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #FFFFFF;
}
#mydiv {
  visibility:visible;
}
.pos-svg-2 {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20%;
  margin-bottom: 10%;
  width: 100%;
}
.pos-svg {
  margin-top: 15%;
  align-items: center;
  width: 100%;
}
.styleSpan {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #1B1918;
  word-spacing: -2px;
  text-align: center;
}
.styleSaveDeclaration {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #49A0A2;
  margin-left: 3%;
  background-color: white;
  border: none;
  margin-top: 4%;
}
.style-btn-document {
  background: #FFFFFF;
  border: 1px solid #49A0A2;
  border-radius: 2px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #49A0A2;
}
.style-btn-chantier {
  background: #49A0A2;
  border-radius: 2px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #FFFFFF;
}


</style>
